<script lang="ts">
    import { cn } from "@/lib/utils";

    export let final: number
    export let current: number
    export let unit: string = ""
    export let finalClass: string
    export let title: string
</script>

<div class="flex flex-col relative justify-center items-center aspect-square w-[90px] text-center rounded p-2 border shadow-sm">
    <span class="text-sm leading-none tracking-tight mb-2">{title}</span>
    <span class={cn("text-2xl font-bold leading-none tracking-tight", finalClass)}>{final}<span class="text-lg">{unit}</span></span>
    <span class="text-muted-foreground leading-none tracking-tighter">
        <i class="fa-regular fa-arrow-up text-xs"/>
        <span class="text-md">{current}</span>
    </span> 
</div>  